import axios from 'axios';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import ReactPaginate from 'react-paginate'
import $ from 'jquery';
import React, { Component, useState } from 'react';
//import "./inscripcionhojasestilocol.css";
import Cookies from 'universal-cookie';
import "../../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import { Alert } from 'bootstrap';

const cookie = new Cookies();
const urlListaUsuariosAdm = ApiUrl + "listusuariosadmdocen" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const listarAsignDocente = ApiUrl + "listarasigndocenteperiod" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlModAsignDocente = ApiUrl + "modificarasigndocente" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlIngrAsignDocente = ApiUrl + "ingresarasigndocente" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlEliminarAsignDocente = ApiUrl + "eliminarasigndocente" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const carrerasUrl = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const devuelNumNivelesCarrera = ApiUrl + "numnivelescarr" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarAsignMatCiclo = ApiUrl + "ListarAsignMatCiclo" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListParalelos = ApiUrl + "listodosparalelos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";


let listaauxiliar = [];
const itemsPerPage = 3;


export default class AsignaturasDocentePeriodoAdm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            estud: [],
            EstudianteBackup: [],
            AsignaturasBackup: [],
            ListAsignaturas: [],
            listanivelesIng: [],
            listaperiodos: [],
            listparalelos: [],
            carrera: [],
            ListAsignaturasIng: [],
            periodos: [],
            carrera_seleccionada: '',
            ciclo_seleccionado: '',
            ruta: "",
            estadoA: "true",
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
            //variables globales
            justClicked: null,

            listroles: [],
            form1: {
            },
        }
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }

    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalRegistroPagoMatricula: false });
            this.setState({ modalModUsuario: false });
        }
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" })
    }

    componentDidMount() {

        $("#divAsignacion").hide();
        $("#divAsignaciontitul").hide();
        $("#divAsignacionAsig").hide();
        $("#divAsignacionBtt").hide();
        //listar todos los periodos
        axios
            .get(urlListPeriodos)
            .then(response => {
                const listaperiodos = response.data.data;
                const cant = listaperiodos.length;
                if (cant != 0) {
                    this.setState({ listaperiodos });
                }
            })
        //listar todos los paralelos
        axios
            .get(urlListParalelos)
            .then(response => {
                if (response.data.success == true) {
                    const listparalelos = response.data.data;
                    const cant = listparalelos.length;
                    if (cant != 0) {
                        this.setState({ listparalelos });
                    }
                }
            })

        axios.get(urlListaUsuariosAdm)
            .then(respuesta => {
                listaauxiliar = respuesta.data.data;
                const estud = listaauxiliar;
                this.setState((state) => {
                    return { estud: estud }
                }
                );
                const EstudianteBackup = estud;

                this.setState((state) => {
                    return { EstudianteBackup: EstudianteBackup }
                });


                //PAGINACION
                this.state.itemOffset = 0;
                const endOffset = this.state.itemOffset + itemsPerPage;
                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                this.setState((state) => {
                    return { itemOffset: state.itemOffset + endOffset }
                });
                //FIN  DE LA PAGINACION
            })
    }
    //BUSQUEDA......
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.estud
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataNombres = item.nombres_administrativo.toUpperCase()
            const itemDataApellidos = item.apellidos_administrativo.toUpperCase()
            const itemDataCedula = item.numero_identificacion_administrativo.toUpperCase()
            const campo = itemDataNombres + " " + itemDataApellidos + " " + itemDataCedula;
            //variable del buscador
            const textData = text.toUpperCase()
            return campo.indexOf(textData) > -1
        })
        if (text == "") {
            newData = this.state.EstudianteBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        })

    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
    }
    //FIN DE PAGINACION
    ocultarModalModificar = () => {
        this.setState({ modalModificar: false });
    }
    seleccionarAdministuno = () => {
        //visualizo  la tabla
        $("#divAsignacion").show();
        $("#divAsignaciontitul").show();
        $("#divAsignacionAsig").show();
        $("#divAsignacionBtt").show();

        var id_adm = 0;
        var nombreAdmin = "";
        var apellidosAdmin = "";

        $(".afiliado:checked").each(function () {
            id_adm = $(this).parent().parent().find('td').eq(0).html();
            nombreAdmin = $(this).parent().parent().find('td').eq(2).html();
            apellidosAdmin = $(this).parent().parent().find('td').eq(3).html();
        });
        var nombresComplet = nombreAdmin + " " + apellidosAdmin;
        this.setState({ nomApellAdmin: nombresComplet });
        this.setState({ idAdmin: id_adm });
        axios
            .post(listarAsignDocente, {
                id_adm: id_adm,
                id_periodo: this.state.idPeriodo
            })
            .then(response => {
                this.setState({ ListAsignaturas: [] });
                this.setState({ ListAsignaturas: response.data.data });
            })
    }

    ingresarDocenteAsignatura = () => {
        document.addEventListener("keydown", this.escFunction, true);

        axios
            .post(urlIngrAsignDocente, {
                idAdministrativo: this.state.idAdmin,
                idAsignatura: this.state.idAsignaturaIng,
                paralelo: this.state.paraleloIng,
                idPeriodo: this.state.idPeriodoIng,
                finicio: this.state.finicioIng,
                ffin: this.state.ffinIng,
                detalle: this.state.detalleIng,
                rol: this.state.rolDocenteAsig,
            })
            .then(response => {
                if (response.data.success === true) {
                    swal({
                        text: "Datos procesados correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });

                
                    //Actualiza los campos del formulario
                    this.setState({ idCarreraIng: '' });
                    this.setState({ rolDocenteAsig: '' });
                    this.setState({ idCicloIng: '' });
                    this.setState({ idAsignaturaIng: '' });
                    this.setState({ idPeriodoIng: '' });
                    this.setState({ paraleloIng: '' });
                    this.setState({ ffinIng: '' });
                    this.setState({ finicioIng: '' });
                    this.setState({ detalleIng: '' });

                    //Actualizar la tabla de asignación
                    axios
                        .post(listarAsignDocente, {
                            id_adm: this.state.idAdmin,
                            id_periodo: this.state.idPeriodo
                        })
                        .then(response => {
                            this.setState({ ListAsignaturas: [] });
                            this.setState({ ListAsignaturas: response.data.data });
                            this.ocultarModalModDocAsign();
                        })



                } else {
                    swal({
                        text: "No se actualizó los datos",
                        icon: "error",
                        button: "Aceptar",
                    });
                    this.setState({ modalPagoColegituraMes: false });

                }
            })
            .catch(error => {

                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",

                });
            });

    }

    modificarDocenteAsignatura = () => {
        var combmsmalert = "¿Está seguro que desea modificar la asignatura?"
        swal({
            title: "Advertencia",
            text: combmsmalert,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {

                    axios
                        .post(urlModAsignDocente, {
                            id: this.state.id,
                            paralelo: this.state.paralelo,
                            rol: this.state.rolDocente,
                            finicio: this.state.finicio,
                            ffin: this.state.ffin,
                            detalle: this.state.detalle,
                        })
                        .then(response => {
                            if (response.data.success === true) {
                                swal({
                                    text: "Datos procesados correctamente",
                                    icon: "success",
                                    button: "Aceptar",
                                });
                                this.seleccionarAdministuno();
                                this.ocultarModalModDocAsign();
                            } else {
                                swal({
                                    text: "No se actualizó los datos",
                                    icon: "error",
                                    button: "Aceptar",
                                });
                                this.setState({ modalmodDocAsignatura: false });

                            }
                        })
                        .catch(error => {
                            this.setState({ error: "No existe conexión con el servidor" });
                            swal({
                                text: "No existe conexión con el servidor",
                                icon: "error",
                                button: "Aceptar",

                            });
                        });
                } else {
                    swal({
                        text: "¡Haz denegado la acción!",
                        icon: "warning",
                        button: "Aceptar",
                    });
                }
            });
    }

    ocultarModalModDocAsign = () => {
        this.setState({ modalmodDocAsignatura: false });
    }

    mostrarModalIngDocAsign = (registro) => {
        axios.get(carrerasUrl)
            .then(res => {
                this.setState({ carrera: res.data });
            })
        this.setState({ modalIngresarAsignatura: true });
        //periodos
        axios.get(ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(respuesta => {
                this.setState({ periodos: respuesta.data.data });
            })
    }

    ocultarModalIngDocAsign = () => {
        this.setState({ modalIngresarAsignatura: false });
    }

    handleChangeDevolverIdCarreraIng = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        axios
            .post(devuelNumNivelesCarrera, {
                idCarreraf: this.state.idCarreraIng,
                periodoIdf: this.state.periodoId,
            })
            .then(response => {
                this.setState({ listanivelesIng: response.data.data });
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    handleChangeDevolverIdCiclo = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        //var  = this.state.idCarrera;
        this.setState({ carrera_seleccionada: this.state.idCarreraIng });
        this.setState({ ciclo_seleccionado: this.state.idCicloIng });
        axios
            .post(UrlListarAsignMatCiclo, {
                idCarrera: this.state.carrera_seleccionada,
                idCiclo: this.state.ciclo_seleccionado,
            })
            .then(response => {
                var array = response.data.data;
                this.setState({ ListAsignaturasIng: array });
            })
    }

    eliminarDocAsign = (registro) => {
        var combmsmalert = "¿Está seguro que desea eliminar la asignación?"
        swal({
            title: "Advertencia",
            text: combmsmalert,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {

                    axios
                        .post(urlEliminarAsignDocente, {
                            id: registro.id_docente_asignatura,
                        })
                        .then(response => {
                            if (response.data.success === true) {
                                swal({
                                    text: "Datos elimados correctamente",
                                    icon: "success",
                                    button: "Aceptar",
                                });
                                //Actualizar la tabla de asignación
                                axios
                                    .post(listarAsignDocente, {
                                        id_adm: this.state.idAdmin,
                                        id_periodo: this.state.idPeriodo
                                    })
                                    .then(response => {
                                        this.setState({ ListAsignaturas: [] });
                                        this.setState({ ListAsignaturas: response.data.data });
                                    })
                            } else {
                                swal({
                                    text: "No se eliminaron los datos",
                                    icon: "error",
                                    button: "Aceptar",
                                });
                                this.setState({ modalmodDocAsignatura: false });

                            }
                        })
                        .catch(error => {
                            this.setState({ error: "No existe conexión con el servidor" });
                            swal({
                                text: "No existe conexión con el servidor",
                                icon: "error",
                                button: "Aceptar",

                            });
                        });
                } else {
                    swal({
                        text: "¡Haz denegado la acción!",
                        icon: "warning",
                        button: "Aceptar",
                    });
                }
            });
    }
    mostrarModalModDocAsign = (registro) => {

        $(function () {
            $("#id").val(registro.id_docente_asignatura);
            $("#docente").val(registro.nombres_administrativo + " " + registro.apellidos_administrativo);
            $("#asignatura").val(registro.descripcion_asignatura);
            $("#paralelo").val(registro.paralelo);
            $("#periodo").val(registro.descripcion_periodo_academico);
            $("#rolDocente").val(registro.rol_docente);
            $("#finicio").val(registro.fecha_inicio_asignatura);
            $("#ffin").val(registro.fecha_fin_asignatura);
            $("#detalle").val(registro.detalle);
        });
        this.setState({ modalmodDocAsignatura: true, form1: registro });
        this.setState({ id: registro.id_docente_asignatura });
        this.setState({ docente: registro.nombres_administrativo + " " + registro.apellidos_administrativo });
        this.setState({ asignatura: registro.descripcion_asignatura });
        this.setState({ paralelo: registro.paralelo });
        this.setState({ periodo: registro.descripcion_periodo_academico });
        this.setState({ rolDocente: registro.rol_docente });
        this.setState({ finicio: registro.fecha_inicio_asignatura });
        this.setState({ ffin: registro.fecha_fin_asignatura });
        this.setState({ detalle: registro.detalle });
    }
    handleChangePeriodo = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })

        axios
            .post(listarAsignDocente, {
                id_adm: this.state.idAdmin,
                id_periodo: this.state.idPeriodo
            })
            .then(response => {
                this.setState({ ListAsignaturas: [] });
                this.setState({ ListAsignaturas: response.data.data });
            })
    }
    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">{/* Título dinámico */}</li>
                </ol>

                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas d-flex align-items-center">
                        <i className="far fa-sticky-note me-2"></i>
                        <b>Reporte de Docentes</b>
                    </div>

                    <div className="p-3 rounded-3">
                        {/* — BUSCAR — */}
                        <div className="row g-3 mb-3">
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-magnifying-glass me-1"></i> Buscar
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={this.state.text}
                                    placeholder="Buscar..."
                                    onChange={e => this.filter(e)}
                                />
                            </div>
                        </div>

                        {/* — TABLA DOCENTES — */}
                        <h6 className="fw-bold text-center mb-3 text-azul small">DOCENTES</h6>
                        <div className="table-responsive mb-4">
                            <table className="table table-sm table-hover align-middle small">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-azul">Cédula</th>
                                        <th className="text-azul">Nombres</th>
                                        <th className="text-azul">Apellidos</th>
                                        <th className="text-azul">Celular</th>
                                        <th className="text-azul">Convencional</th>
                                        <th className="text-azul">Email</th>
                                        <th className="text-azul">Dirección</th>
                                        <th className="text-azul">Seleccionar</th>
                                    </tr>
                                </thead>
                                <tbody className="text-azul">
                                    {this.state.currentItems && this.state.currentItems.map(doc => (
                                        <tr key={doc.id_administrativo} className="list-afiliados">
                                            {/* ID oculto para mantener eq(0) */}
                                            <td className="oculto" style={{ display: 'none' }}>
                                                {doc.id_administrativo}
                                            </td>
                                            <td>{doc.numero_identificacion_administrativo}</td>
                                            <td>{doc.nombres_administrativo}</td>
                                            <td>{doc.apellidos_administrativo}</td>
                                            <td>{doc.celular_administrativo}</td>
                                            <td>{doc.convencional_administrativo}</td>
                                            <td>{doc.email_administrativo}</td>
                                            <td>{doc.direccion_administrativo}</td>
                                            <td className="text-center">
                                                <input
                                                    type="radio"
                                                    name="afiliado"
                                                    onChange={this.seleccionarAdministuno}
                                                    className="afiliado form-check-input"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* — PAGINADOR — */}
                        <div className="d-flex justify-content-center mb-4">
                            <ReactPaginate
                                previousLabel="<"
                                nextLabel=">"
                                pageCount={this.state.pageCount}
                                onPageChange={this.handlePageClick}
                                containerClassName="pagination pagination-sm-custom"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                activeClassName="active"
                            />
                        </div>

                        <div id="divAsignacion" className="row g-3 align-items-end mb-3" >
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-calendar me-1"></i> Período
                                </label>
                                <select
                                    id="idPeriodo"
                                    name="idPeriodo"
                                    className="form-select form-select-sm"
                                    value={this.state.idPeriodo}
                                    onChange={this.handleChangePeriodo}
                                >
                                    <option value="undefined" selected disabled>Seleccione el período</option>
                                    {this.state.listaperiodos && this.state.listaperiodos.map(p => (
                                        <option key={p.id_periodo_academico} value={p.id_periodo_academico}>
                                            {p.descripcion_periodo_academico}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* — ASIGNATURAS DESIGNADAS — */}
                        <h6 id="divAsignaciontitul" className="fw-bold mb-3 text-azul small">ASIGNATURAS DESIGNADAS</h6>

                        <div id="divAsignacionAsig" className="table-responsive">
                            <table
                                id="tablaasignaturas"
                                name="tablaasignaturas"
                                width="100%"
                                className="table table-sm table-hover align-middle small"
                            >
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-azul">CARRERA</th>
                                        <th className="text-azul">NIVEL</th>
                                        <th className="text-azul">CÓDIGO</th>
                                        <th className="text-azul">ASIGNATURA</th>
                                        <th className="text-azul">PARALELO</th>
                                        <th className="text-azul">PERIODO</th>
                                        <th className="text-azul">FECHA INICIO</th>
                                        <th className="text-azul">FECHA FIN</th>
                                        <th className="text-azul">ROL</th>
                                        <th className="text-azul">ESTADO ACTA</th>
                                        <th className="text-azul">MODIFICAR</th>
                                        <th className="text-azul">ELIMINAR</th>
                                    </tr>
                                </thead>
                                <tbody className="text-azul">
                                    {this.state.ListAsignaturas && this.state.ListAsignaturas.map(item => (
                                        <tr key={item.administrativo_id}>
                                            {/* Si usas ID oculto aquí, vuelve a ponerlo como primera <td> */}
                                            <td>{item.descripcion_carrera}</td>
                                            <td>{item.nivel_asignatura}</td>
                                            <td className="mes">{item.codigo_asignatura}</td>
                                            <td className="mes">{item.descripcion_asignatura}</td>
                                            <td className="mes">{item.nombre_paralelo}</td>
                                            <td className="mes">{item.descripcion_periodo_academico}</td>
                                            <td className="mes">{item.fecha_inicio_asignatura}</td>
                                            <td className="mes">{item.fecha_fin_asignatura}</td>
                                            <td className="mes">{item.rol_docente}</td>
                                            <td>
                                                <span className={item.estadoacta === 0 ? 'text-warning small' : 'text-success small'}>
                                                    {item.estadoacta === 0 ? 'Pendiente' : 'Registrado'}
                                                </span>
                                            </td>
                                            <td className="text-center">
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() => this.mostrarModalModDocAsign(item)}
                                                    disabled={item.estadoacta === 1}
                                                >
                                                    <i className="fas fa-clipboard-list"></i>
                                                </button>
                                            </td>
                                            <td className="text-center">
                                                <button
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => this.eliminarDocAsign(item)}
                                                    disabled={item.estadoacta === 1}
                                                >
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* — NUEVA ASIGNACIÓN — */}
                        <div className="text-center mt-4">
                            <button
                                className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                onClick={this.mostrarModalIngDocAsign}
                                id="divAsignacionBtt"
                            >
                                Nueva Asignación
                            </button>
                        </div>

                        <Modal isOpen={this.state.modalmodDocAsignatura}>
                            <ModalHeader>
                                <div className="small mb-0 text-white">Asignatura</div>
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <div className="row g-3">
                                        {/* ID oculto */}
                                        <input type="hidden" name="id" id="id" onChange={this.handleChange} />

                                        <div className="col-12">
                                            <label className="form-label text-azul small">Docente</label>
                                            <input
                                                type="text"
                                                id="docente"
                                                name="docente"
                                                className="form-control form-control-sm"
                                                disabled
                                            />
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Asignatura</label>
                                            <input
                                                type="text"
                                                id="asignatura"
                                                name="asignatura"
                                                className="form-control form-control-sm"
                                                disabled
                                            />
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Periodo Académico</label>
                                            <input
                                                type="text"
                                                id="periodo"
                                                name="periodo"
                                                className="form-control form-control-sm"
                                                disabled
                                            />
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Rol del Docente</label>
                                            <select
                                                className="form-select form-select-sm"
                                                name="rolDocente"
                                                id="rolDocente"
                                                onChange={this.handleChange}
                                            >
                                                <option value="" disabled>Seleccione el rol</option>
                                                <option value="Principal">Principal</option>
                                                <option value="Auxiliar">Auxiliar</option>
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Paralelo</label>
                                            <select
                                                className="form-select form-select-sm"
                                                name="paralelo"
                                                id="paralelo"
                                                onChange={this.handleChange}
                                            >
                                                <option value="" disabled>Seleccione paralelo</option>
                                                {this.state.listparalelos?.map(p => (
                                                    <option key={p.id_paralelo} value={p.id_paralelo}>
                                                        {p.nombre_paralelo}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Fecha Inicio</label>
                                            <input
                                                type="date"
                                                id="finicio"
                                                name="finicio"
                                                className="form-control form-control-sm"
                                                onChange={this.handleChange}
                                            />
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Fecha Fin</label>
                                            <input
                                                type="date"
                                                id="ffin"
                                                name="ffin"
                                                className="form-control form-control-sm"
                                                onChange={this.handleChange}
                                            />
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label text-azul small">Detalle</label>
                                            <input
                                                type="text"
                                                id="detalle"
                                                name="detalle"
                                                className="form-control form-control-sm"
                                                onChange={this.handleChange}
                                            />
                                        </div>
                                    </div>
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={this.modificarDocenteAsignatura}
                                >
                                    Modificar
                                </button>
                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={this.ocultarModalModDocAsign}
                                >
                                    Salir
                                </button>
                            </ModalFooter>
                        </Modal>

                        {/* Modal para nueva asignación */}
                        <Modal isOpen={this.state.modalIngresarAsignatura}>
                            <ModalHeader>
                                <div className="small mb-0 text-white">Asignación de Asignatura al Docente</div>
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <label className="form-label text-azul small">Docente</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                value={this.state.nomApellAdmin}
                                                disabled
                                            />
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Carrera</label>
                                            <select
                                                id="idCarreraIng"
                                                name="idCarreraIng"
                                                className="form-select form-select-sm"
                                                value={this.state.idCarreraIng}
                                                onChange={this.handleChangeDevolverIdCarreraIng}
                                            >
                                                <option value="" selected disabled>Seleccione una carrera</option>
                                                {this.state.carrera.map(c => (
                                                    <option key={c.id_carrera} value={c.id_carrera}>
                                                        {c.descripcion_carrera}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Rol del Docente</label>
                                            <select
                                                id="rolDocenteAsig"
                                                name="rolDocenteAsig"
                                                className="form-select form-select-sm"
                                                value={this.state.rolDocenteAsig}
                                                onChange={this.handleChange}
                                            >
                                                <option value="" selected disabled>Seleccione el rol</option>
                                                <option value="Principal">Principal</option>
                                                <option value="Auxiliar">Auxiliar</option>
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Ciclo</label>
                                            <select
                                                id="idCicloIng"
                                                name="idCicloIng"
                                                className="form-select form-select-sm"
                                                value={this.state.idCicloIng}
                                                onChange={this.handleChangeDevolverIdCiclo}
                                            >
                                                <option value="" selected disabled>Seleccione un ciclo</option>
                                                {this.state.listanivelesIng.map(l => (
                                                    <option key={l.codnivel} value={l.codnivel}>
                                                        {l.codnivel}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Asignatura</label>
                                            <select
                                                id="idAsignaturaIng"
                                                name="idAsignaturaIng"
                                                className="form-select form-select-sm"
                                                value={this.state.idAsignaturaIng}
                                                onChange={this.handleChangeDevolverIdCiclo}
                                            >
                                                <option value="" selected disabled>Seleccione una asignatura</option>
                                                {this.state.ListAsignaturasIng.map(a => (
                                                    <option key={a.id_asignatura} value={a.id_asignatura}>
                                                        {a.descripcion_asignatura}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Período</label>
                                            <select
                                                id="idPeriodoIng"
                                                name="idPeriodoIng"
                                                className="form-select form-select-sm"
                                                value={this.state.idPeriodoIng}
                                                onChange={this.handleChangeDevolverIdCiclo}
                                            >
                                                <option value="" selected disabled>Seleccione un periodo</option>
                                                {this.state.periodos.map(p => (
                                                    <option key={p.id_periodo_academico} value={p.id_periodo_academico}>
                                                        {p.descripcion_periodo_academico}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Paralelo</label>
                                            <select
                                                id="paraleloIng"
                                                name="paraleloIng"
                                                className="form-select form-select-sm"
                                                value={this.state.paraleloIng}
                                                onChange={this.handleChange}
                                            >
                                                <option value="" selected disabled>Seleccione paralelo</option>
                                                {this.state.listparalelos.map(p => (
                                                    <option key={p.id_paralelo} value={p.id_paralelo}>
                                                        {p.nombre_paralelo}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Fecha Inicio</label>
                                            <input
                                                type="date"
                                                id="finicioIng"
                                                name="finicioIng"
                                                className="form-control form-control-sm"
                                                value={this.state.finicioIng}
                                                onChange={this.handleChange}
                                            />
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label text-azul small">Fecha Fin</label>
                                            <input
                                                type="date"
                                                id="ffinIng"
                                                name="ffinIng"
                                                className="form-control form-control-sm"
                                                value={this.state.ffinIng}
                                                onChange={this.handleChange}
                                            />
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label text-azul small">Detalle</label>
                                            <input
                                                type="text"
                                                id="detalleIng"
                                                name="detalleIng"
                                                className="form-control form-control-sm"
                                                value={this.state.detalleIng}
                                                onChange={this.handleChange}
                                            />
                                        </div>
                                    </div>
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={this.ingresarDocenteAsignatura}
                                >
                                    Ingresar
                                </button>
                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={this.ocultarModalIngDocAsign}
                                >
                                    Salir
                                </button>
                            </ModalFooter>
                        </Modal>
                    </div>
                </div>
            </div>
        )
    }
}

